import { Component } from '@angular/core';

@Component({
  selector: 'app-merge-pdf-content',
  imports: [],
  templateUrl: './merge-pdf-content.component.html',
  styleUrl: './merge-pdf-content.component.css'
})
export class MergePdfContentComponent {

}
